import { FC } from 'react'

import { clsx } from 'clsx'

import { HTMLTribeProps } from '../types/index.js'

export type TextAlign = 'leading' | 'center' | 'trailing'
export type TextSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
export type TextBold = 'light' | 'medium' | 'heavy'
export type TextColor =
  | 'default'
  | 'primary'
  | 'positive'
  | 'negative'
  | 'attention'
  | 'highlight'

export type TextProps = HTMLTribeProps<'span'> & {
  align?: TextAlign
  size?: TextSize
  truncate?: boolean
  bold?: TextBold
  color?: TextColor
}

export const Text: FC<TextProps> = props => {
  const {
    align = 'leading',
    size = 'md',
    as,
    className,
    truncate,
    bold,
    color,
    children,
    ...rest
  } = props
  const Component = as || 'span'

  return (
    <Component
      className={clsx(
        [
          align === 'leading' && 'text-start',
          align === 'center' && 'text-center',
          align === 'trailing' && 'text-end',
        ],
        [
          size === 'xs' && 'text-xs',
          size === 'sm' && 'text-sm',
          size === 'md' && 'text-base',
          size === 'lg' && 'text-lg',
          size === 'xl' && 'text-xl',
          size === '2xl' && 'text-2xl',
        ],
        truncate && 'truncate',
        bold && [
          bold === 'light' && 'font-medium',
          bold === 'medium' && 'font-semibold',
          bold === 'heavy' && 'font-bold',
        ],
        color && [
          color === 'default' && 'text-content-subdued',
          color === 'primary' && 'text-action-primary',
          color === 'positive' && 'text-content-on-positive',
          color === 'negative' && 'text-content-on-negative',
          color === 'attention' && 'text-content-on-attention',
          color === 'highlight' && 'text-content-on-highlight',
        ],
        className,
      )}
      {...rest}
    >
      {children}
    </Component>
  )
}
